export default __webpack_public_path__ + "5e4c51ec7913770158454bf7923a0077.svg";